import React from 'react';
interface QuizQuestionProps {
  title: string;
  children: React.ReactNode;
}
export function QuizQuestion({
  title,
  children
}: QuizQuestionProps) {
  return <div className="w-full max-w-2xl mx-auto" data-id="element-103">
      <h2 className="text-2xl md:text-3xl font-bold text-crown-text mb-8" data-id="element-104">
        {title}
      </h2>
      <div className="space-y-3" data-id="element-105">{children}</div>
    </div>;
}